const codeSnippets = [
    {
        title: "🚀 Launch the Rocket!",
        code: `function launchRocket() {
    console.log("🚀 Ignition sequence start...");
    setTimeout(() => console.log("🚀 Liftoff!"), 3000);
  }
  launchRocket();`,
    },

    {
        title: "🎲 Roll a Dice",
        code: `function rollDice() {
    return Math.floor(Math.random() * 6) + 1;
  }
  console.log("🎲 You rolled a", rollDice());`,
    },

    {
        title: "🐱 Cat Talk",
        code: `function meow(times) {
    return "🐱 Meow ".repeat(times).trim();
  }
  console.log(meow(3));`,
    },

    {
        title: "🍪 Grab a Cookie",
        code: `function eatCookie() {
    console.log("🍪 Nom nom... Delicious!");
  }
  eatCookie();`,
    },

    {
        title: "🦄 Summon a Unicorn",
        code: `function summonUnicorn() {
    console.log("✨ A magical unicorn appears! 🦄✨");
  }
  summonUnicorn();`,
    },

    {
        title: "🤖 Friendly AI",
        code: `function greet() {
    console.log("🤖 Hello, human! I am your friendly AI.");
  }
  greet();`,
    },

    {
        title: "🌍 Earthquake Detector",
        code: `function detectEarthquake() {
    console.log("🌍 Detecting seismic activity...");
    setTimeout(() => console.log("🌍 No earthquake detected!"), 2000);
  }
  detectEarthquake();`,
    },

    {
        title: "🔥 Spicy Food Test",
        code: `function eatSpicy() {
    console.log("🌶️ This is fine...");
    setTimeout(() => console.log("🔥 AHH! Water!"), 2000);
  }
  eatSpicy();`,
    },

    {
        title: "🐍 Snek Game Starter",
        code: `function snekMove(direction) {
    console.log(\`🐍 The snake moves \${direction}!\`);
  }
  snekMove("right");`,
    },

    {
        title: "🚗 Speed Racer",
        code: `function race(speed) {
    console.log(\`🏎️ Zooming at \${speed} mph!\`);
  }
  race(120);`,
    },
];


export default codeSnippets;